/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 * Page Account Info Selectors
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.11.0
 */

import { createSelector } from 'reselect';

import type { ITableButtonTypes } from '../../components/Table/types/tableFooterButtonsTypes';
import { accountInfoApi } from './store';
import type { TAccountInfoButtonsEnabled } from './types/pageAccountInfoGeneralTypes';

const accountInfoMetaApiSelector = (clientId: string) =>
  accountInfoApi.endpoints.getAccountInfoMeta.select({ clientId });

export const makeSelectAccountInfoGeneralMeta = (clientId: string) =>
  createSelector(accountInfoMetaApiSelector(clientId), ({ data }) => data);

export const makeSelectAccountInfoGeneralMetaIsSingle = (clientId: string) =>
  createSelector(
    accountInfoMetaApiSelector(clientId),
    ({ data }) => data?.isSingle,
  );

export const makeSelectAccountInfoButtonsEnabled = (clientId: string) =>
  createSelector(
    accountInfoMetaApiSelector(clientId),
    ({ data }) =>
      data?.buttons?.reduce(
        (buttons: TAccountInfoButtonsEnabled, button: ITableButtonTypes) => {
          buttons[button.buttonName] = true;
          return buttons;
        },
        {},
      ) || {},
  );
